import { ref } from 'vue'
import GLOBAL from '../../utils/GLOBAL'

// Pega o lang  da URL
export const lang = ref(GLOBAL.generateObjFilter()?.lang || 'pt-BR')

